export function beginStopwatch() {
  const t0 = performance.now();
  return {
    done: () => {
      // eslint-disable-next-line no-console
      return `${Math.trunc(performance.now() - t0)}ms`;
    },
  };
}
